import { StudentsDTO } from '../../../api/Students/GetAllStudentsByCourse';
import StudentsFreezeRow from "./StudentsFreezeRow";

const StudentsFreezeTable = ({ data, courseId }: { data?: StudentsDTO[], courseId: string }) => {



    return (
        <div>
            <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
                <table className="table-auto w-full">
                    <thead className="text-lg capitalize ">
                        <tr className="bg-[#F1F4F9] rounded-t-lg">
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Full Name
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Email
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Phone
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Country
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Status
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Subscription Ends
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Remove
                                </div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">
                                    Set Expiry Date
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {data?.map((student: StudentsDTO) => (
                            <StudentsFreezeRow
                                key={student.id}
                                country={student.country}
                                fullName={`${student.fullName}`}
                                phone={student.phone}
                                email={student.email}
                                courseId={courseId}
                                studentId={student.id}
                                frozen={student.frozen}
                                subscriptionEndsAt={student.subscriptionEndsAt}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentsFreezeTable;
